// extracted by mini-css-extract-plugin
export var actionButton = "_ld-t";
export var buttonContainer = "_ld-0";
export var buttonContainer2 = "_ld-1";
export var buttonSection = "_ld-2";
export var details = "_ld-3";
export var dropdownItem = "_ld-5";
export var dropdownItemsContainer = "_ld-4";
export var fileInput = "_ld-r";
export var headerButton = "_ld-6";
export var icon = "_ld-7";
export var input = "_ld-8";
export var macroListItem = "_ld-9";
export var mainContent = "_ld-a";
export var microText = "_ld-b";
export var modal = "_ld-w";
export var optionsButton = "_ld-c";
export var paperclip = "_ld-s";
export var pillContent = "_ld-d";
export var preview = "_ld-e";
export var preview2 = "_ld-f";
export var quillEditor = "_ld-q";
export var selectedMacro = "_ld-g";
export var sidebar = "_ld-h";
export var sidebarHeader = "_ld-j";
export var sidebarList = "_ld-i";
export var sidebarListItem = "_ld-k";
export var sidebarSearch = "_ld-l";
export var snoozeDurationWrapper = "_ld-v";
export var statusPillContainer = "_ld-m";
export var tagsContainer = "_ld-n";
export var unselectedMacro = "_ld-o";
export var variable = "_ld-u";
export var wrapper = "_ld-p";